import { fieldSchemaRegistry } from '@tectonics/utils/validation';
import type { CountrySchema } from '@tectonics/prs/country';
import type { IncomingPayment } from '@tectonics/prs/incoming-payment';
import type { onlyWhenSupport } from '@tectonics/prs/validation';
import { z } from 'zod';

export const buildGenericSchema = ({ onlyWhen, optionalFields, countrySchema, incomingPayment }: {
  readonly onlyWhen: ReturnType<typeof onlyWhenSupport>;
  readonly optionalFields: readonly string[];
  readonly countrySchema: CountrySchema;
  readonly incomingPayment: IncomingPayment;
}) => {
  const schemaDefinition: Record<string, z.ZodType> = {};

  const { fields, country } = countrySchema;

  for (const field of fields) {
    const optionalFieldName = field.optional_field_name ?? field.id;
    const isRequiredField = !optionalFields.includes(optionalFieldName);
    const isSupportedField = onlyWhen(field.id);
    const isDisabledField = field.disabled?.({ incomingPayment }) ?? false;
    const isReadOnlyField = field.readOnly?.({ incomingPayment }) ?? false;

    if (isSupportedField && isRequiredField && !isDisabledField && !isReadOnlyField) {
      const fieldSchema = fieldSchemaRegistry.get(field.validation);

      if (!fieldSchema) {
        throw new Error(`No schema found for validation rule: ${field.validation}`);
      }

      schemaDefinition[field.id] = fieldSchema({ country });
    }
  }

  return z.object(schemaDefinition);
};
